import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import type { User } from "@shared/schema";
import { SIDE_EVENTS_HOST } from "@shared/sideEventsHub";

type AuthUser = User & { activeRoles?: string[] };

export function useAuth() {
  const isIsolatedSideEventsHost = typeof window !== "undefined" && window.location.hostname === SIDE_EVENTS_HOST;
  const { data: user, isLoading, error } = useQuery<AuthUser | null>({
    queryKey: ["/api/auth/user"],
    retry: false,
    enabled: !isIsolatedSideEventsHost,
  });

  const hasRole = useCallback((role: string): boolean => {
    if (!user) return false;
    return user.activeRoles?.includes(role) ?? false;
  }, [user]);

  return {
    user,
    isLoading: isIsolatedSideEventsHost ? false : isLoading,
    isAuthenticated: !!user,
    error,
    activeRoles: user?.activeRoles ?? [],
    hasRole,
  };
}
